import React from 'react'

import { StyledTopDecorationFrame as S } from './TopDecorationFrame.styles'

export const TopDecorationFrame: React.FC = () => {
  return <S.Root />
}
